import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling with Lenis + hash-anchor handling
// (both same-page clicks and initial load with a #hash, e.g. arriving
// from a subpage via "/#metodo").
export default function SmoothScroll({ children }) {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let lenis;
    let rafId;
    if (!prefersReduced) {
      lenis = new Lenis({
        duration: 1.1,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      window.__lenis = lenis;
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    }

    const scrollToEl = (el) => {
      if (!el) return;
      if (lenis) lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    };

    // Apply an initial #hash after the page has painted (and again on full load).
    let hashTimer;
    const applyHash = () => {
      if (window.location.hash && window.location.hash.length > 1) {
        const el = document.querySelector(window.location.hash);
        scrollToEl(el);
      }
    };
    if (window.location.hash && window.location.hash.length > 1) {
      hashTimer = setTimeout(applyHash, 450);
      window.addEventListener("load", applyHash);
    }

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      const raw = a.getAttribute("href");
      const hash = raw.startsWith("/#") ? raw.slice(1) : raw;
      if (hash.length > 1) {
        const el = document.querySelector(hash);
        // Only intercept when the target exists on the current page.
        if (el) {
          e.preventDefault();
          scrollToEl(el);
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (hashTimer) clearTimeout(hashTimer);
      window.removeEventListener("load", applyHash);
      document.removeEventListener("click", onClick);
      if (lenis) {
        lenis.destroy();
        delete window.__lenis;
      }
    };
  }, []);

  return children;
}
